import { atom } from 'jotai';

import {
  type TAction,
  type TGroup,
  type TMode,
  type TModePath,
  type TModeStackFrame,
  type TModifiers,
  type TType,
} from './types';

/**
 * Registry state for the Spotlight command layer. These live next to the store
 * (not in `src/atoms`) because they are typed by the store's `T*` types. Feature
 * code writes and reads them only through the store's API and selectors; the sole
 * direct reader is the `Spotlight` host component, which subscribes to a few for
 * rendering.
 */

/** All registered actions, in registration order (each carries its attached mode path). */
export const spotlightActionsAtom = atom<TAction[]>([]);

/** Render strategies, keyed by `type`. */
export const spotlightTypesAtom = atom<Record<string, TType>>({});

/** Groups, keyed by `key`. */
export const spotlightGroupsAtom = atom<Record<string, TGroup>>({});

/** Registered modes, keyed by mode path. */
export const spotlightModesAtom = atom<Record<TModePath, TMode>>({});

/** Mode data, keyed by mode path. Surfaced per-frame in `ctx.modePath`. */
export const spotlightModeDataAtom = atom<Record<TModePath, unknown>>({});

/** The active mode stack — id-tagged path frames, bottom → top. Current path = top (empty ⇒ root). */
export const spotlightModeStackAtom = atom<TModeStackFrame[]>([]);

/** Baseline the live mode path resets to on every close. */
export const spotlightDefaultModeAtom = atom<TModePath>('/');

/** Live modifier-key state while the Spotlight is open (render hints only). */
export const spotlightModifiersAtom = atom<TModifiers>({
  cmd: false,
  ctrl: false,
  shift: false,
  opt: false,
});

/** The current search query. */
export const spotlightQueryAtom = atom('');
